import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { of, switchMap } from 'rxjs';
import { UserSettings } from 'shared/models/user-settings.model';
import { SettingsService } from 'shared/services/settings.service';
import { Utils } from 'shared/utils/utils';

export const SubscriptionGuard: CanActivateFn | CanActivateChildFn = (route, state) =>
{
    const router: Router = inject(Router);

    // let minSubscription = 0;
    // if(Utils.isDefined(route,"data.minSubscription")) minSubscription = route.data['minSubscription']
    // Check the authentication status
    return inject(SettingsService).getUserSettings().pipe(
        switchMap((userSettings:UserSettings) =>
        {
            if (!userSettings) {
                return of(router.createUrlTree(['/login']));
            }
            
            const premiumDays = Utils.checkSubscriptionDays(userSettings.subscription)

            if (premiumDays <= 0)
            {
                console.log(`[SubscriptionGuard]: Access available only for active subscription. No premium days left. Redirecting...`)
                // router.navigate(['/account/my-account/subscription/expired']);
                return of(router.createUrlTree(['/account/my-account/subscription/expired']));
            }

            // // If the user is authenticated...
            // if (userSettings?.userData?.premiumType < minSubscription)
            // {
            //     console.log(`[SubscriptionGuard]: Access available only from ${minSubscription} subscription. Redirecting...`)
            //     router.navigate(['/account/my-account/subscription/extend']);
            //     return of(true)
            // }
            // lol23
            // Allow the access
            return of(true);
        }),
    );
};